import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TestrunJiraBugsPopover from './TestrunJiraBugsPopover';
import { Link } from '@mui/material';
import OverflowTooltip from '@shared/components/ui/OverflowTooltip';

const JiraBugsCell = ({ jiraBugs, testRunResultId }) => {
    const { t } = useTranslation();
    const [popoverAnchorEl, setPopoverAnchorEl] = useState(null);

    if (!jiraBugs?.length) {
        return '–';
    }

    return (
        <>
            <TestrunJiraBugsPopover
                anchorEl={popoverAnchorEl}
                setAnchorEl={setPopoverAnchorEl}
                jiraBugs={jiraBugs}
                testRunResultId={testRunResultId}
            />
            {jiraBugs.length > 1 ? (
                <Link
                    underline="hover"
                    sx={{ cursor: 'pointer' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        setPopoverAnchorEl(e.currentTarget);
                    }}
                >
                    {t('jira_bugsWithCount', { count: jiraBugs.length })}
                </Link>
            ) : (
                <OverflowTooltip title={jiraBugs[0].split('/')?.at(-1) || 'bug'}>
                    <Link underline="hover" href={jiraBugs[0]} target="_blank" sx={{ cursor: 'pointer' }}>
                        {jiraBugs[0].split('/')?.at(-1) || 'bug'}
                    </Link>
                </OverflowTooltip>
            )}
        </>
    );
};

export default JiraBugsCell;
